import { BackgroundLayoutRoot } from "./BackgroundLayout.styles";
import { ReactNode } from "react";
import clsx from "clsx";

interface BackgroundLayoutProps {
    children?: ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export default function BackgroundLayout({ className, ...rest }: BackgroundLayoutProps): JSX.Element {
    return <BackgroundLayoutRoot className={clsx("background-layout", className)} {...rest} />;
}
